import React from 'react';
import { connect } from 'react-redux';

import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';

/**
 * Allow global custom css for all pages.
 */
class CustomCode extends React.PureComponent {
    static defaultProps = {
        css: undefined,
    };

    render() {
        const { css } = this.props;
        return css ? <style dangerouslySetInnerHTML={Helpers.createMarkup(css)}></style> : null
    }
}


const mapStateToProps = (state, ownProps) => {
    // possible tempory for controlling this optimization from page component
    const globalCustomCode = state.globalCustomCode || {};
    return { css: globalCustomCode.css };
};

export default withError(connect(mapStateToProps, null)(CustomCode));